import { Pipe, PipeTransform } from '@angular/core';
import { Temperature } from 'src/app/enum/temperature';
import { TemperatureHelper } from 'src/app/helper/temperature/temperature-helper';
import { StringHelper } from 'src/app/helper/string/string-helper';
import { AuthService } from 'src/app/service/auth/auth.service';

@Pipe({
	name: 'temperature',
})
export class TemperaturePipe implements PipeTransform {
	
	constructor(private authService: AuthService) { }

	transform(value: number, ...args: string[]): string {
		if (!value && value !== 0) {
			return 'N/A';
		}
		let unit = 'ºC';
		const temperatureUnit = this.authService.company?.temperature_unit;
		if (
			(temperatureUnit?.slug === Temperature.Fahrenheit && args?.indexOf('reverse') < 0) ||
			(temperatureUnit?.slug !== Temperature.Fahrenheit && args?.indexOf('reverse') >= 0)
		) {
			value = TemperatureHelper.toFahrenheit(value);
			unit = 'ºF';
		}
		if (args?.indexOf('unit') < 0) {
			unit = '';
		}
		return StringHelper.sprintf('%d%s', value, unit);
	}
}
